import { createActionCreator } from "deox";
import { ITransactionYearModel } from "../../../types/types";

export const transactionYearsLoading = createActionCreator(
  "transactionYears/loading"
);
export const transactionYearsLoadingError = createActionCreator(
  "transactionYears/loadingError",
  (resolve) => (error: string) => resolve(error)
);

export const transactionYearsLoaded = createActionCreator(
  "transactionYears/loaded",
  (resolve) => (payload: ITransactionYearModel[]) => resolve(payload)
);

export const transactionYearCreating = createActionCreator(
  "transactionYear/creating"
);
export const transactionYearCreatingError = createActionCreator(
  "transactionYear/creatingError",
  (resolve) => (error: string) => resolve(error)
);

export const transactionYearCreated = createActionCreator(
  "transactionYear/created",
  (resolve) => (payload: ITransactionYearModel) => resolve(payload)
);

export const resetTransactionYearCreateState = createActionCreator(
  "transactionYear/resetCreateState"
);

//actions to delete a transaction year
export const transactionYearDeleting = createActionCreator(
  "transactionYear/deleting"
);
export const transactionYearDeletingError = createActionCreator(
  "transactionYear/deletingError",
  (resolve) => (error: string) => resolve(error)
);
export const transactionYearDeleted = createActionCreator(
  "transactionYear/deleted",
  (resolve) => (payload: number) => resolve(payload)
);

export const resetTransactionYearDeleteState = createActionCreator(
  "transactionYear/resetDeleteState"
);
